module.exports = __webpack_public_path__ + "static/media/DrObertin.c059a66b.jpg";